<template>
  <ag-select
    :id="id"
    :value="value"
    :options="tags"
    @change="$emit('change', $event)"
    placeholder="Select or add a tag"
    label="name"
    :multiple="true"
    :taggable="true"
    @tag="addTag"
  />
</template>

<script>
  export default {
    name: "TagSelect",
    props: {
      id: String,
      value: Array
    },
    data: () => ({
      tags: []
    }),
    async mounted() {
      try {
        const tags = await this.$service.recipe.findAllTags();

        this.tags = tags.map(tag => {
          return {
            id: tag.id,
            label: tag.name
          }
        })
        
      } catch (e) {
        console.error(`Error loading tags`, e);
      }
    },
    methods: {
      addTag(name) {
        const newItem = {
          // any number lower than 1 will signify that a new tag needs added to db
          id: parseFloat(`0.${this.tags.length + 1}`),
          label: name
        };
        this.tags.push(newItem);
        this.$emit('change', newItem);
      }
    }
  };
</script>

<style scoped lang="scss"></style>
